import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconColumnTwoVerticalComponent } from "./med-icon-column-two-vertical.component";

@NgModule({
  declarations: [
    MedIconColumnTwoVerticalComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconColumnTwoVerticalComponent,
  ],
})
export class MedIconColumnTwoVerticalModule { }
